import React, {useState} from "react";
import "./eml-offers-checker.scss";

const EMLOffersChecker = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const handleFileChange = (event) => {
        const file = event.target.files?.[0];

        if (!file) {
            setSelectedFile(null);
            setError("");
            return;
        }

        const isValidExtension = /\.(csv|xls|xlsx)$/i.test(file.name);

        if (!isValidExtension) {
            setSelectedFile(null);
            setError("Unsupported file type. Please upload a CSV, XLS or XLSX file.");
            return;
        }

        setSelectedFile(file);
        setError("");
    };

    const handleSubmit = async () => {
        if (!selectedFile) {
            return;
        }

        const loggedUserEmail = localStorage.getItem("email");

        if (!loggedUserEmail) {
            setError("User email not found.");
            return;
        }

        setLoading(true);
        setError("");
        setSuccessMessage("");

        try {
            const formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("email", loggedUserEmail);

            const localToken = localStorage.getItem("auth_token");

            const response = await fetch(
                `${localStorage.getItem("apiUrl")}api/offers-status-check`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${localToken}`,
                    },
                    body: formData,
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            setSuccessMessage(data.message);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="eml-offers-checker">
            <div className="upload-card">
                <div className="upload-card__header">
                    <div>
                        <p className="upload-title">Upload file</p>
                        <p className="upload-subtitle">
                            Accepted formats: .csv, .xls, .xlsx
                        </p>
                    </div>

                    {selectedFile ? (
                        <span className="upload-status success">File ready</span>
                    ) : (
                        <span className="upload-status muted">No file</span>
                    )}
                </div>

                <div className="expected-columns">
                    <p className="expected-columns__title">You can use the following column names in the uploaded
                        file:</p>
                    <p className="expected-columns__list">
                        Geo · Campaign index · AN name · Brand Name · Link · Status · Offer id · Service Id · Weight
                    </p>
                </div>

                <label className="upload-dropzone">
                    <input
                        type="file"
                        accept=".csv,.xls,.xlsx"
                        onChange={handleFileChange}
                    />
                    <div className="upload-dropzone__content">
                        <p className="upload-dropzone__title">
                            {selectedFile ? "Change file" : "Choose a file"}
                        </p>
                        <p className="upload-dropzone__hint">
                            Drag & drop or click to browse
                        </p>
                        {selectedFile ? (
                            <p className="upload-dropzone__file">
                                {selectedFile.name}
                            </p>
                        ) : null}
                    </div>
                </label>

                {error ? <p className="upload-error">{error}</p> : null}
                {successMessage ? (
                    <p className="upload-success">{successMessage}</p>
                ) : null}

                <button
                    className="blue-btn upload-submit"
                    disabled={!selectedFile || loading}
                    onClick={handleSubmit}
                >
                    {loading ? "Processing..." : "Check offers"}
                </button>
            </div>
        </div>
    );
};

export default EMLOffersChecker;
